<ion-content>
  <div style="padding: 16px" class="constrained-content">
    <ion-label class="input-label"> Name <ion-text color="warning" *ngIf="!id">(Required)</ion-text></ion-label>
    <ion-input #nameInput placeholder="e.g. IT" [(ngModel)]="name" class="input-field" style="font-size: 1.1rem">
    </ion-input>

    <ion-label class="input-label"> Description </ion-label>
    <ion-textarea
      #descriptionInput
      placeholder="e.g. Issues related to information technology and hardware"
      [(ngModel)]="description"
      class="input-field"
      rows="3"
      [autoGrow]="true"
    >
    </ion-textarea>

    <div style="margin-bottom: 20px">
      <ion-label class="input-label">Bot Configuration</ion-label>
      <ion-card class="support-team-form-container">
        <div class="notification-preview">
          <div
            class="notification-icon"
            style="width: 50px; height: 50px; border-radius: 8px; border: 1px solid var(--input-border-color)"
          >
            <ion-button slot="end" size="full" fill="clear" (click)="uploadSupportLogo()" class="icon-upload-button">
              <ion-icon name="cloud-upload-outline" [ngClass]="{ hide: !!supportLogo }"></ion-icon>
            </ion-button>
            <img *ngIf="supportLogo" [src]="supportLogo" />
          </div>
          <div>
            <ion-input
              placeholder="Unthread"
              [(ngModel)]="supportName"
              class="select-outline"
              style="margin-left: 5px; height: 50px; font-size: 1.1rem"
            >
            </ion-input>
          </div>
        </div>

        <div [hidden]="!id" style="margin: 10px 0">
          <ion-label class="input-label"> AI Agent Instructions </ion-label>
          <ion-textarea
            placeholder="Specific instructions for the AI agent handling this project. e.g. Use a friendly tone, request specific details when handling tickets"
            [(ngModel)]="instructions"
            class="input-field"
            rows="4"
            [autoGrow]="true"
          >
          </ion-textarea>
        </div>
      </ion-card>

      <ion-label class="input-label">Assignment & SLA</ion-label>
      <ion-card class="support-team-form-container" *ngIf="isInitialized">
        <app-support-steps
          [isDefaults]="true"
          [initialSupportSteps]="supportSteps"
          [projectId]="id"
          (didChange)="supportStepsDidChange($event)"
        ></app-support-steps>
      </ion-card>
      <ion-card class="support-step-card" *ngIf="!isInitialized" style="margin-top: 20px">
        <ion-list-header>
          <ion-skeleton-text [animated]="true" style="width: 80px"></ion-skeleton-text>
        </ion-list-header>
        <ion-item>
          <ion-skeleton-text [animated]="true" slot="start" style="width: 30px"></ion-skeleton-text>
          <ion-label>
            <h3>
              <ion-skeleton-text [animated]="true" style="width: 80%"></ion-skeleton-text>
            </h3>
          </ion-label>
        </ion-item>
      </ion-card>
      <ion-card class="support-step-card" *ngIf="!isInitialized" style="margin-top: 20px">
        <ion-item>
          <ion-skeleton-text [animated]="true" slot="start" style="width: 55px"></ion-skeleton-text>
          <ion-label>
            <h3>
              <ion-skeleton-text [animated]="true" style="width: 50%"></ion-skeleton-text>
            </h3>
          </ion-label>
        </ion-item>
        <ion-item>
          <ion-skeleton-text [animated]="true" slot="start" style="width: 60px"></ion-skeleton-text>
          <ion-label>
            <h3>
              <ion-skeleton-text [animated]="true" style="width: 30%"></ion-skeleton-text>
            </h3>
          </ion-label>
        </ion-item>
        <ion-item>
          <ion-skeleton-text [animated]="true" slot="start" style="width: 50px"></ion-skeleton-text>

          <ion-label>
            <h3>
              <ion-skeleton-text [animated]="true" style="width: 45%"></ion-skeleton-text>
            </h3>
          </ion-label>
        </ion-item>
      </ion-card>
      <a href="https://docs.unthread.io/conversations/slas" target="_blank" class="settings-learn-more">
        <ion-icon name="book-outline"></ion-icon>
        Learn more about SLAs and assignment rules
      </a>
    </div>

    <div style="margin-bottom: 20px" [hidden]="!id">
      <ion-label class="input-label">Project Configuration</ion-label>
      <ion-card class="support-team-form-container" style="padding: 20px">
        <div class="inline-note-container" [hidden]="!id">
          <ion-label class="input-label"> Triage Channel </ion-label>
          <ion-note class="input-label">
            Learn more about <a href="https://docs.unthread.io/conversations/triaging" target="_blank">triaging</a>
          </ion-note>
        </div>
        <ion-chip
          mode="ios"
          class="select-chip select-outline input-field no-margin"
          [outline]="true"
          (click)="setDefaultTriageChannel()"
          [hidden]="!id"
        >
          <ion-label>
            <span [ngClass]="{ 'text-muted': !defaultTriageChannel }">
              {{ defaultTriageChannel?.name ?? 'None set' }}
            </span>
            <ion-icon name="chevron-down-outline" class="icon-padded-left button-icon"></ion-icon>
          </ion-label>
        </ion-chip>
        <ion-button
          color="dark"
          fill="clear"
          (click)="defaultTriageChannel = null; defaultTriageChannelId = null"
          *ngIf="defaultTriageChannel"
          class="btn-small"
          style="margin-bottom: 11px; font-size: 0.7rem; margin-top: 0"
          [hidden]="!id"
        >
          Remove
        </ion-button>

        <div class="inline-note-container" [hidden]="!id">
          <ion-label class="input-label"> Default ticket type </ion-label>

          <ion-note class="input-label">
            This will be set for new conversations that the AI is unable to categorize.
          </ion-note>
        </div>
        <div [hidden]="!id">
          <ion-chip
            mode="ios"
            class="select-chip select-outline input-field no-margin"
            [outline]="true"
            (click)="setDefaultTicketType()"
          >
            <ion-label [ngClass]="{ 'text-muted': !defaultTicketType }">
              {{ defaultTicketType?.name ?? 'None set' }}
              <ion-icon name="chevron-down-outline" class="icon-padded-left button-icon"></ion-icon>
            </ion-label>
          </ion-chip>
        </div>

        <div class="inline-note-container" [hidden]="!id">
          <ion-label class="input-label"> Triage message template </ion-label>
          <ion-note class="input-label"> Add custom content to triage messages in this project. </ion-note>
        </div>
        <div [hidden]="!id">
          <ion-chip
            mode="ios"
            class="select-chip select-outline input-field no-margin"
            [outline]="true"
            (click)="setTriageMessageTemplate()"
          >
            <ion-label [ngClass]="{ 'text-muted': !triageMessageTemplate }">
              {{ triageMessageTemplate?.name ?? 'None set' }}
              <ion-icon name="chevron-down-outline" class="icon-padded-left button-icon"></ion-icon>
            </ion-label>
          </ion-chip>
        </div>

        <div class="inline-note-container">
          <ion-label class="input-label"> Working hours </ion-label>
          <ion-note class="input-label"> Working hours influence response and resolution times. </ion-note>
        </div>
        <div [hidden]="!id">
          <ion-chip
            mode="ios"
            class="select-chip select-outline input-field no-margin"
            [outline]="true"
            (click)="manageWorkingHours()"
          >
            <ion-label> Set working hours (currently {{ workingHoursEnabled ? 'enabled' : 'disabled' }}) </ion-label>
          </ion-chip>
        </div>
      </ion-card>
    </div>

    <ion-label class="input-label"> Visibility </ion-label>
    <ion-select
      [(ngModel)]="visibility"
      interface="popover"
      placeholder="Project visibility"
      aria-label="Project visibility"
      class="select-outline input-field"
    >
      <ion-select-option value="public"> Public </ion-select-option>
      <ion-select-option value="restricted"> Restricted </ion-select-option>
    </ion-select>

    <ion-label class="input-label"> Type </ion-label>
    <ion-select
      [(ngModel)]="isExternal"
      interface="popover"
      placeholder="Project type"
      aria-label="Project type"
      class="select-outline input-field"
    >
      <ion-select-option [value]="true"> External Support </ion-select-option>
      <ion-select-option [value]="false"> Internal Support </ion-select-option>
    </ion-select>
  </div>
</ion-content>

<ion-footer class="footer">
  <div class="constrained-content flex-space-between">
    <div>
      <ion-button (click)="submit()" [disabled]="isLoading">
        Save
        <ion-spinner name="crescent" [hidden]="!isLoading" style="margin-left: 10px"></ion-spinner>
      </ion-button>
      <ion-button (click)="viewInInbox()" fill="clear" color="dark" [disabled]="isLoading" [hidden]="!id">
        <ion-icon name="file-tray-outline"></ion-icon>
        <span class="hidden-sm text-with-left-icon">View conversations</span>
      </ion-button>
    </div>
    <ion-button
      fill="clear"
      color="dark"
      (click)="delete()"
      [disabled]="isLoading"
      *ngIf="id"
      ngxTippy
      data-tippy-content="Delete"
    >
      <ion-icon name="trash-outline"></ion-icon>
    </ion-button>
  </div>
</ion-footer>
